(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("osjsGui", [], factory);
	else if(typeof exports === 'object')
		exports["osjsGui"] = factory();
	else
		root["osjsGui"] = factory();
})(window, function() {
return 